/**
 * Security and Device Utilities
 */

/**
 * Generate a cryptographically secure CSRF token (64-character hex string)
 * @returns {string} CSRF token
 */
export const generateCSRFToken = () => {
  try {
    return Array.from(
      crypto.getRandomValues(new Uint8Array(32)),
      b => b.toString(16).padStart(2, '0')
    ).join('');
  } catch {
    // Fallback for environments without crypto.getRandomValues
    return Math.random().toString(36).substring(2) + Date.now().toString(36);
  }
};

/**
 * Generate a random Device ID string
 * @returns {string} Device ID
 */
export const generateDeviceId = () => {
  return Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
};

/**
 * Retrieve the current Device ID from localStorage, or generate and store a new one
 * @returns {string} Device ID
 */
export const getOrCreateDeviceId = () => {
  if (typeof window === 'undefined') return 'server-device';
  let deviceId = localStorage.getItem('device_id');
  if (!deviceId) {
    deviceId = generateDeviceId();
    localStorage.setItem('device_id', deviceId);
  }
  return deviceId;
};
